import type { ReactNode } from 'react';

export function EmptyState({ title, text, action }: { title: string; text: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-lg border border-dashed bg-secondary/40 px-5 py-7 text-center">
      <p className="text-[15px] font-semibold text-foreground">{title}</p>
      <p className="max-w-sm text-[13.5px] text-muted-foreground">{text}</p>
      {action}
    </div>
  );
}
